
export interface SpaciousPerformanceEntry {
  performance_entry_type: string
  performance_entry_name: string

  performance_entry_start_time: DOMHighResTimeStamp
  performance_entry_duration:   DOMHighResTimeStamp

  performance_entry_start_time_minus_tti?:  number,
  performance_entry_duration_minus_tti?:    number,

  [key: string]: any
}

interface FakeArrayForPush {
  push(e: SpaciousPerformanceEntry): void
  forEach(callback: (e: SpaciousPerformanceEntry) => void): void
}

window.spacious_post_tti_performance_entries = window.spacious_post_tti_performance_entries || []


//region spacious_post_tti_performance_entries

declare global {
  interface Window {
    spacious_post_tti_performance_entries: SpaciousPerformanceEntry[] | FakeArrayForPush
  }
}

let local_tti_in_ms: null | number = null

const TTI_DIFF_ENTRY_TYPES: string[] = [
  "resource",
  "longtask",
  "measure",
]

function processOnePerformanceEntries(entry: SpaciousPerformanceEntry) {
  if (TTI_DIFF_ENTRY_TYPES.includes(entry.performance_entry_type) && local_tti_in_ms != null) {
    entry.performance_entry_start_time_minus_tti =
      entry.performance_entry_start_time - local_tti_in_ms
    entry.performance_entry_end_time_minus_tti =
      (entry.performance_entry_start_time + entry.performance_entry_duration) - local_tti_in_ms
  }

  fetch("/api/web_app/user_performance_data_entries", {
    method: "POST",
    cache:  "no-cache",

    // Don't think we need credentials for performance data
    credentials:  "omit",
    redirect:     "error",

    // Allow the request to be sent even page closed
    keepalive: true,

    headers: {
      "Content-Type": "application/json",
      // AJAX simulation
      "X-Requested-With": "XMLHttpRequest",
    },
    // body data type must match "Content-Type" header
    body: JSON.stringify(entry),
  })
  .catch(() => {
    // Do nothing
    // Properly timeout or network issue
  })
}

const fake_spacious_post_tti_performance_entries_array: FakeArrayForPush = {
  push: (e: SpaciousPerformanceEntry) => {
    processOnePerformanceEntries(e)
  },
  // This is just to match with type definition
  forEach() {
    // empty
  },
}

function processAllPerformanceEntries(tti_in_ms: null | number) {
  local_tti_in_ms = tti_in_ms

  // Only enable instant script loading after loading all pending scripts
  let pending_spacious_post_tti_performance_entries = [] as SpaciousPerformanceEntry[] | FakeArrayForPush
  if (window.spacious_post_tti_performance_entries !== fake_spacious_post_tti_performance_entries_array) {
    pending_spacious_post_tti_performance_entries = window.spacious_post_tti_performance_entries || []
    window.spacious_post_tti_performance_entries = fake_spacious_post_tti_performance_entries_array
  }

  pending_spacious_post_tti_performance_entries.forEach(processOnePerformanceEntries)
}

//endregion spacious_post_tti_performance_entries

export {
  processAllPerformanceEntries,
}
